import React from 'react';
import {
    Paper,
    ListItem,
    Box,
    Avatar,
    Typography,
    Divider,
    Grid, withStyles
} from '@material-ui/core';
import PropTypes from 'prop-types';
import NumberStepper from '../NumberStepper';
import styles from './styles'

function TourStopCard(props) {
    
    const { stop, color, boxTypes, editedStops, onAmountChange, classes } = props;
    
    return (
        <Paper
            elevation={2}
            className={classes.stopCard}
            style={{
                borderLeft: `6px solid ${color}`
            }}
        >
            <ListItem disableGutters className={classes.listItem}>
                <Box className={classes.avatarContainer}>
                    <Box className={classes.avatarContainer}>
                        <Avatar
                            className={classes.avatar}
                            style={{
                                backgroundColor: color,
                                color: '#ffffff'
                            }}
                        >
                            {stop.stopNumber}
                        </Avatar>
                    </Box>
                </Box>

                <Box className={classes.contentContainer}>
                    <Box className={classes.addressBox}>
                        <Typography variant="h6" className={classes.addressText}>
                            {stop.address?.streetAndNumber}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            {stop.address?.zipCode || stop.address?.zipcode} {stop.address?.city}
                        </Typography>
                    </Box>

                    <Typography variant="body1" className={classes.nameText}>
                        {stop.firstName} {stop.lastName}
                    </Typography>

                    <Divider light className={classes.divider} />

                    <Grid container spacing={2} alignItems="center" className={classes.grid}>
                        {boxTypes.map(boxType => {
                            const existingProduct = stop.products?.find(
                                p => p.boxType === boxType.identifier
                            );
                            const initialValue = existingProduct ? existingProduct.amount : 0;
                            const editedValue = editedStops[stop.tourStopId]?.[boxType.boxTypeId];
                            const currentValue = editedValue !== undefined ? editedValue : initialValue;

                            return (
                                <Grid
                                    item
                                    xs={12}
                                    key={boxType.boxTypeId}
                                    className={classes.boxTypeGrid}
                                >
                                    <Typography variant="body2">
                                        {boxType.identifier}
                                    </Typography>

                                    <NumberStepper
                                        value={currentValue}
                                        onChange={(newValue) => onAmountChange(stop.tourStopId, boxType.boxTypeId, newValue)}
                                    />
                                </Grid>
                            );
                        })}
                    </Grid>
                </Box>
            </ListItem>
        </Paper>
    );
}

TourStopCard.propTypes = {
    stop: PropTypes.object.isRequired,
    color: PropTypes.string,
    boxTypes: PropTypes.array.isRequired,
    editedStops: PropTypes.object.isRequired,
    onAmountChange: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(TourStopCard);